// extracted by mini-css-extract-plugin
export default {"root":"Board_root__hPd-+","wrapper":"Board_wrapper__wnWWF","container":"Board_container__Wcx1+","list__container":"Board_list__container__y0XZc"};